export const SERVER_URL = "http://etpgaranzia.com:8080/garanzia";
// export const SERVER_URL = "http://localhost:8080/";